module.exports = __webpack_public_path__ + "img/sk-partners-kryptomagazin.62b5fc20.png";